var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "product-category-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.basicFields')))]), _vm._v(" "), (_vm.showTenant) ? _c('tenant-combobox', {
    attrs: {
      "label": _vm.$t('fields.tenant'),
      "errors": _vm.fields.errors.tenant,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.tenant),
      callback: function($$v) {
        _vm.fields.values.tenant = $$v
      },
      expression: "fields.values.tenant"
    }
  }) : _c('product-category-combobox', {
    attrs: {
      "label": _vm.$t('fields.parent'),
      "errors": _vm.fields.errors.parent,
      "filter": {
        omittedIds: _vm.omittedParentIds
      },
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.parent),
      callback: function($$v) {
        _vm.fields.values.parent = $$v
      },
      expression: "fields.values.parent"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "name",
    attrs: {
      "label": _vm.$t('fields.name'),
      "errors": _vm.fields.errors.name,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.name),
      callback: function($$v) {
        _vm.fields.values.name = $$v
      },
      expression: "fields.values.name"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": _vm.$t('fields.categoryNumber'),
      "errors": _vm.fields.errors.categoryNumber,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.categoryNumber),
      callback: function($$v) {
        _vm.fields.values.categoryNumber = $$v
      },
      expression: "fields.values.categoryNumber"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.seo')))]), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": _vm.$t('fields.slug'),
      "errors": _vm.fields.errors.slug,
      "disabled": !_vm.isEditable,
      "placeholder": _vm.slugPlaceholder
    },
    model: {
      value: (_vm.fields.values.slug),
      callback: function($$v) {
        _vm.fields.values.slug = $$v
      },
      expression: "fields.values.slug"
    }
  }), _vm._v(" "), _c('readonly-form-field', {
    attrs: {
      "label": _vm.$t('fields.path')
    }
  }, [(_vm.path) ? _c('span', [_vm._v(_vm._s(_vm.path))]) : _c('text-placeholder')], 1), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "label": _vm.$t('fields.aliases'),
      "errors": _vm.fields.errors.aliases,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.aliases),
      callback: function($$v) {
        _vm.fields.values.aliases = $$v
      },
      expression: "fields.values.aliases"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-medium-top"
  }, [_c('submit-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isSubmittable
    }
  }), _vm._v(" "), _c('cancel-button')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea55bb74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductCategoryForm.vue
// module id = 2135
// module chunks = 0